export const getAllCharacters = (state) => {
  return state.characters.characterIds.map((id) => state.characters.charactersById[id]);
};

export const getCarouselCharacters = (state) => {
  const characters = getAllCharacters(state);
  const filteredCharacters = characters.filter((item) => item.displayInCarousel);

  return filteredCharacters;
};

export const getCharacterById = (state, id) => {
  return state.characters.charactersById[id];
};

export const getCharacterByUrl = (state, url) => {
  const characters = getAllCharacters(state);

  return characters.find((item) => item.friendly_url === url) || false;
};
